import React from 'react';

var DefaultValueComponent = function DefaultValueComponent(_ref) {
  var selectedItem = _ref.selectedItem;
  return (
    /* @__PURE__ */
    React.createElement(React.Fragment, null, selectedItem.text)
  );
};

export { DefaultValueComponent };